import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme)=>({
    appBar:{
        backgroundColor:'rgba(255,255,255,.9)'
    },
    menuButton: {
        marginRight: '1px',
        color:'blue',
      },
      title: {
        flexGrow: 1,
      },
      buttons: {
        marginRight: "5px",
        padding:'10px',
        fontSize:'10px',
        color:'white',
        background:'blue',
        outline:'none',
        transition:'all 0.3s',
        width:'75px',
        '&:hover':{
            cursor:'pointer',
            background:'white',
            color:'blue'
        },
        borderRadius:'5px',
        '@media (max-width: 400px)' : {
            fontSize:'0.6em',
          }
      },
      footer:{
          position:'relative',
          width:'100%',
        backgroundColor:theme.palette.background.paper,
        paddingTop:'50px 0',

    },
    // appBar:{
    //     backgroundColor:'rgba(255,255,255,.7)'
    // }
}));
export default useStyles;